import { HttpErrorResponse } from '@angular/common/http';
import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import {
  DxButtonComponent,
  DxDataGridComponent,
  DxPopupComponent,
} from 'devextreme-angular';
import {
  DxiButtonComponent,
  DxiColumnComponent,
  DxiItemComponent,
  DxiValidationRuleComponent,
  DxoEditingComponent,
  DxoExportComponent,
  DxoFilterRowComponent,
  DxoFormComponent,
  DxoLookupComponent,
  DxoPagerComponent,
  DxoPagingComponent,
  DxoPopupComponent,
  DxoTextsComponent,
} from 'devextreme-angular/ui/nested';
import CustomStore from 'devextreme/data/custom_store';
import notify from 'devextreme/ui/notify';
import { BehaviorSubject, firstValueFrom } from 'rxjs';
import { Articoli } from 'src/app/models/articoli';
import { CategorieArticoli } from 'src/app/models/categorieArticoli';
import { DettaglioMovimento } from 'src/app/models/dettaglio-movimento';
import { DipendentiArticoliDettaglio } from 'src/app/models/dipendenti-articoli-dettaglio';
import { TipiArticoli } from 'src/app/models/tipi-articoli';
import { ArticoliService } from 'src/app/shared/services/articoli.service';
import { CategorieArticoliService } from 'src/app/shared/services/categorie-articoli.service';
import { DettaglioArticoloDipendenteService } from 'src/app/shared/services/dettaglio-articolo-dipendente.service';
import { KitArticoliService } from 'src/app/shared/services/kit-articoli.service';
import { ParametriService } from 'src/app/shared/services/parametri.service';
import { StorageService } from 'src/app/shared/services/storage.service';
import { TipiArticoliService } from 'src/app/shared/services/tipi-articoli.service';
import { ConvertError } from 'src/app/utils/gestione-errori';
import { GridExportExcel } from 'src/app/utils/grid-export-excel';
import { notificaMessaggio } from 'src/app/utils/notifiche-utils';

@Component({
  selector: 'app-articoli-previsti-by-dipendente',
  templateUrl: './articoli-previsti-by-dipendente.component.html',
  styleUrls: ['./articoli-previsti-by-dipendente.component.scss'],
  imports: [
    DxDataGridComponent,
    DxButtonComponent,
    DxiColumnComponent,
    DxoPagingComponent,
    DxoPagerComponent,
    DxoFilterRowComponent,
    DxoTextsComponent,
    DxoPopupComponent,
    DxoFormComponent,
    DxoEditingComponent,
    DxiButtonComponent,
    DxoLookupComponent,
    DxiValidationRuleComponent,
    DxiItemComponent,
    DxPopupComponent,
    DxButtonComponent,
    DxoExportComponent,
  ],
  standalone: true,
})
export class ArticoliPrevistiByDipendenteComponent
  implements OnInit, OnChanges {
  private dettArtDipService = inject(DettaglioArticoloDipendenteService);
  private categoriaArticoliService = inject(CategorieArticoliService);
  private articoliService = inject(ArticoliService);
  private tipiArticoliService = inject(TipiArticoliService);
  private kitArticoliService = inject(KitArticoliService);
  private storageService = inject(StorageService);
  private parametriS = inject(ParametriService);

  @ViewChild('gridArticoliDip', { static: false })
  dataGrid!: DxDataGridComponent;

  @Input() idDipendente!: number;
  @Input() idMansione!: number;
  @Input() bConsultazione: boolean = false;
  @Input() listDetArtDip: any;
  @Input() tipoFiltro: string = ''; // M: manuale A:Automatico
  @Input() filtro!: number;
  //togliere, mettere observable
  @Input() listDettaglioBS = new BehaviorSubject<DettaglioMovimento[]>([]);
  @Output() listEventEmitter = new EventEmitter<
    DipendentiArticoliDettaglio[]
  >();

  dataSource: any;
  articoliDipendentiList: DipendentiArticoliDettaglio[] = [];
  bEditing: boolean = false;

  listCatArt: CategorieArticoli[] = []; // categorie Articoli
  selectedCat: number = 0;

  listArticoli: Articoli[] = []; // Lista Articoli
  listArticoliFiltrati: Articoli[] = []; // Lista Articoli Filtrati
  listTipiArticoli: TipiArticoli[] = []; //Lista TipiArticoli
  listTipiArticoliByMansione: TipiArticoli[] = []; // TipiArticoli By Mansione
  listTipiArticoliFiltrati: TipiArticoli[] = []; // Lista Tipi Articoli Filtrati
  listDettaglio: DettaglioMovimento[] = [];

  dettaglioMovimento: DettaglioMovimento = new DettaglioMovimento(); // Utilizzato per consegna nuova articolo al dipendente

  popupKit: boolean = false;
  idArticoloKit?: number = undefined;
  controlloSottoscorta: number = -1;

  constructor() {
    this.getFilteredArticoli = this.getFilteredArticoli.bind(this);
    this.assegnaArticolo = this.assegnaArticolo.bind(this);
  }

  ngOnInit() {
    this.loadCategorieArticoli(); //Carico le categorie degli articoli
    this.loadArticoli(); // Carico lista articoli
    this.loadTipiArticolo(); // Carico lista tipi Articolo
    this.loadParametro();
    console.log(this.listDettaglioBS.value);
    this.listDettaglioBS.subscribe(list => {
      this.listDettaglio = [...list];
    });
  }

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    // ngOnChanges(changes: SimpleChanges) {
    const dipendenteChanged =
      changes['idDipendente'] &&
      changes['idDipendente'].currentValue !==
      changes['idDipendente'].previousValue;

    const mansioneChanged =
      changes['idMansione'] &&
      changes['idMansione'].currentValue !==
      changes['idMansione'].previousValue;

    const filtroChanged =
      changes['filtro'] &&
      changes['filtro'].currentValue !== changes['filtro'].previousValue;

    if (this.idMansione && mansioneChanged) {
      await this.loadTipiArticoliByMansione(); //Carico i tipi Articoli della mansione
    }

    if (this.idDipendente && dipendenteChanged) {
      await this.loadArticoliDip(); // aspetto il caricamento prima di fare altro
    }

    if (this.filtro && filtroChanged) {
      this.filterByCategory(this.filtro);
    }
  }

  getFilteredArticoli(options: any) {
    const ret = {
      store: this.listArticoliFiltrati,
      filter: options.data
        ? ['idTipo', '=', options.data.idTipoArticolo]
        : null,
    };
    return ret;
  }

  setTipoValue(rowData: any, value: any): void {
    rowData.idArticolo = null;
    (this as any).defaultSetCellValue(rowData, value);
  }

  // Lista Categorie
  loadCategorieArticoli() {
    this.categoriaArticoliService.listTemp().subscribe({
      next: (res) => {
        if (res != null) {
          this.listCatArt = res;
        }
      }
    });
  }

  //Lista Articoli
  loadArticoli() {
    this.articoliService.listTemp().subscribe({
      next: (res) => {
        if (res != null) {
          this.listArticoli = res.filter(x => x.attivo == true).sort((a, b) =>
            a.descrizione < b.descrizione ? -1 : 1,
          );
          this.listArticoliFiltrati = this.listArticoli;
        }
      }
    });
  }

  //Lista Tipi Articoli
  loadTipiArticolo() {
    this.tipiArticoliService.list().subscribe({
      next: (res) => {
        if (res != null) {
          this.listTipiArticoli = res.sort((a, b) =>
            a.descrizione < b.descrizione ? -1 : 1,
          );
          this.listTipiArticoliFiltrati = this.listTipiArticoli;
        }
      },
      error: (error) => {
        ConvertError(error, 'Errore recupero tipi articolo');
      },
    });
  }

  //Tipi Articoli ByMansione
  loadTipiArticoliByMansione() {
    this.tipiArticoliService.listByMansione(this.idMansione).subscribe({
      next: (res) => {
        if (res != null) {
          this.listTipiArticoliByMansione = res;
        } else {
          notificaMessaggio(
            'Non sono presenti tipi articoli per la mansione',
            'warning',
          );
          //this.navService.goToHome();
        }
      },
      error: (error) => {
        ConvertError(error, 'Errore recupero tipi articoli by mansione');
      },
    });
  }

  loadParametro() {
    this.parametriS.get('verifica-sottoscorta').subscribe({
      next: (dati) => {
        this.controlloSottoscorta = dati.valNum;
      },
      error: (error) => {
        if (error?.error?.text) {
          const errT = error?.error?.text();
          const errj = JSON.parse(errT);
          notify(errj?.title, 'warning', 3000);
        } else {
          notify('Errore caricamento parametro sottoscorta', 'error', 3000);
        }
      },
    });
  }

  getArticoloDisplayExpr(item: Articoli) {
    if (!item) {
      return '';
    }
    return (
      item.codice +
      ' - ' +
      item.descrizione +
      (item.taglia ? ' - ' + item.taglia : '')
    );
  }

  getTitleButton(id: number, descrizione: string) {
    if (id > 0) {
      return (
        descrizione +
        ' (' +
        this.articoliDipendentiList?.filter((x) => x.idCategoria == id).length +
        ')'
      );
    } else {
      return descrizione + ' (' + this.articoliDipendentiList?.length + ')';
    }
  }

  filterByCategory(catId: number) {
    this.selectedCat = catId;
    // console.log('Categoria selezionata:', catId);

    //Filtro la grid
    this.dataGrid?.instance.clearFilter(); // Pulisco filtro grid
    this.listArticoliFiltrati = this.listArticoli;
    this.listTipiArticoliFiltrati = this.listTipiArticoli;

    if (catId && catId > 0) {
      //Filtro la grid per la categori selezionata
      this.dataGrid.instance.filter([['idCategoria', '=', catId]]);

      //Filtro i tipi articoli per categoria
      if (this.listTipiArticoli) {
        this.listTipiArticoliFiltrati = this.listTipiArticoli?.filter(
          (x) => x.idCategoria == catId,
        );
        const taFiltrati = this.listTipiArticoli?.filter(
          (x) => x.idCategoria == catId,
        );
        //Filtro gli articoli per tipo articoli
        this.listArticoliFiltrati = this.listArticoli?.filter((a) =>
          taFiltrati.some((t) => t.id === a.idTipo),
        ); // se esiste almeno una tipologia
      }
    }
  }

  loadArticoliDip() {
    this.dataSource = new CustomStore({
      key: ['idArticolo', 'idDipendente'],
      load: () => {
        return firstValueFrom(
          this.dettArtDipService.listByDipendente(this.idDipendente),
        )
          .then((response) => {
            this.articoliDipendentiList = response;
            this.listEventEmitter.emit(this.articoliDipendentiList);

            // Applica filtro solo dopo caricamento dati
            if (this.filtro && this.filtro > 0) {
              setTimeout(() => this.filterByCategory(this.filtro), 0);
            }

            return {
              data: response,
            };
          })
          .catch((error: HttpErrorResponse) => {
            throw error.error.title;
          });
      },
      /* load: (loadOptions) => {        
         return this.articoliList;
       },
       */

      byKey: (values) => {
        return firstValueFrom(
          this.dettArtDipService.get(values.idArticolo, values.idDipendente),
        ).catch((error: HttpErrorResponse) => {
          //throw 'Deletion failed'
          console.log(error.error.title);
          throw error.error.title;
        });
      },
      insert: (values) => {
        values.idDipendente = this.idDipendente;
        return firstValueFrom(this.dettArtDipService.insert(values))
          .then(() => {
            return values;
            //this.loadArticoliDip();
          })
          .catch((error: HttpErrorResponse) => {
            //throw 'Deletion failed'
            console.log(error.error.title);
            throw error.error.title;
          });
      },
      remove: (values) => {
        return firstValueFrom(
          this.dettArtDipService.remove(values.idArticolo, values.idDipendente),
        )
          .then(() => {
            //this.loadArticoliDip();
          })
          .catch((error: HttpErrorResponse) => {
            //throw 'Deletion failed'
            console.log(error.error.title);
            throw error.error.title;
          });
      },
      update: (key, values) => {
        return firstValueFrom(
          this.dettArtDipService.update(
            key.idArticolo,
            key.idDipendente,
            values,
          ),
        )
          .then(() => {
            // this.loadArticoliDip();
          })
          .catch(() => {
            throw 'Update failed';
          });
      },
    });
  }

  onUpdating(e: any) {
    e.newData = Object.assign(e.oldData, e.newData);
  }

  onInitNewRow() {
    this.bEditing = true;
  }

  onEditingStart() {
    this.bEditing = false;
  }

  onRowPrepared(e: any) {
    if (e.rowType == 'data') {
      if (this.idMansione) {
        if (
          this.listTipiArticoliByMansione?.filter(
            (x) => x.id == e.data.idTipoArticolo,
          ).length > 0
        ) {
          e.rowElement.style.backgroundColor = '#b6e5c1';
        }
      }
    }
  }

  assegnaArticolo(e: any) {
    // console.log('id Articolo aggiunto:' + e.row.data.idArticolo);
    this.listDettaglio = this.listDettaglioBS.value;
    const index = this.listDettaglio.findIndex(
      (x) => x.idArticolo == e.row.data.idArticolo,
    );
    if (index >= 0) {
      this.listDettaglio[index].qta += e.row.data.quantita != undefined && e.row.data.quantita != null && e.row.data.quantita > 0 ? e.row.data.quantita : 1;
    } else {
      this.dettaglioMovimento = new DettaglioMovimento();
      this.dettaglioMovimento.idArticolo = e.row.data.idArticolo;
      this.dettaglioMovimento.idTipoArticolo = e.row.data.idTipoArticolo;
      this.dettaglioMovimento.qta = e.row.data.quantita != undefined && e.row.data.quantita != null && e.row.data.quantita > 0 ? e.row.data.quantita : 1;
      this.dettaglioMovimento.cambio =
        this.storageService.paramLoginCorrente.cambioConsegna;
      this.dettaglioMovimento.usaMatricola = this.listTipiArticoli!.find(
        (x) => x.id == e.row.data.idTipoArticolo,
      )!.usaMatricola;
      this.listDettaglio.push(this.dettaglioMovimento);
    }
    if (e.row.data.gestioneKit) {
      this.idArticoloKit = e.row.data.idArticolo;
      this.popupKit = true;
    } else {
      console.log(this.listDettaglioBS.value);
      this.listDettaglioBS.next([...this.listDettaglioBS.value]);
      console.log(this.listDettaglioBS.value);
      this.listDettaglio = [];
      notify('articolo previsto assegnato', 'success', 1800);
    }
  }

  onConfermaKit() {
    this.kitArticoliService.listByIdArticolo(this.idArticoloKit!).subscribe({
      next: (res) => {
        const articoloKitInserito = this.listDettaglio.find(
          (x) => x.idArticolo == this.idArticoloKit,
        );
        const idsArticolicComponenti = res.map((x) => x.idArticoloComponente);

        res.forEach((art) => {
          const articoloComponente = this.listArticoli.find(
            (x) => x.id == art.idArticoloComponente,
          );
          if (
            articoloComponente!.giacenza <
            articoloKitInserito!.qta * art.quantita &&
            this.controlloSottoscorta > 0
          ) {
            if (this.controlloSottoscorta > 1) {
              this.listDettaglio = this.listDettaglio.filter(
                (x) => !idsArticolicComponenti.includes(x.idArticolo),
              );
            }
            notificaMessaggio(
              'Giacenza non disponibile per tutti i componenti del kit',
              'warning',
            );
            this.popupKit = false;
            this.listDettaglioBS.next(
              this.listDettaglioBS.value.filter(articolo => articolo.idArticolo !== art.idArticolo)
            );
            this.listDettaglio = [];
            return;
          }
          const index = this.listDettaglio.findIndex(
            (x) => x.idArticolo == articoloComponente!.id,
          );
          if (index >= 0) {
            this.listDettaglio[index].qta +=
              articoloKitInserito!.qta * art.quantita;
            return;
          }
          const temp = new DettaglioMovimento();
          temp.idArticolo = articoloComponente!.id;
          temp.idTipoArticolo = articoloComponente!.idTipo;
          temp.qta = articoloKitInserito!.qta * art.quantita;
          temp.cambio = this.storageService.paramLoginCorrente.cambioConsegna;
          temp.usaMatricola = this.listTipiArticoli!.find(
            (x) => x.id == articoloComponente!.idTipo,
          )!.usaMatricola;
          this.listDettaglio.push(temp);
          this.listDettaglioBS.next([...this.listDettaglioBS.value, temp]);

          notify('articolo previsto assegnato', 'success', 1800);
        });

        this.popupKit = false;
      },
      error: (err) => {
        if (err?.error?.title) {
          notificaMessaggio(err.error.title, 'error');
        } else {
          notificaMessaggio('Errore recupero articoli componenti kit', 'error');
        }
        this.popupKit = false;
      },
    });
  }

  onDiniegoKit() {
    this.idArticoloKit = undefined;
    this.popupKit = false;
  }

  onExporting(e: any) {
    GridExportExcel(e, 'Ultime Consegne', 'Articoli_previsti.xlsx');
  }

  getQuantitaDisplay(item: DipendentiArticoliDettaglio) {
    return item.quantita != undefined && item.quantita > 0 ? item.quantita : 1;
  }
}
